import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE = new InjectionToken<Storage>('LOCAL_STORAGE', {
  providedIn: 'root',
  factory: () => {
    return typeof window !== 'undefined'
      ? window.localStorage
      : ({
          getItem: () => {
            return null;
          },
          setItem: () => {},
          removeItem: () => {},
          key: () => {
            return null;
          },
          length: 0,
          clear: () => {},
        } as unknown as Storage);
  },
});
